import type { UbaProduct } from '../types'

import { HiMinus, HiPlus } from 'react-icons/hi'
import { HiXMark } from 'react-icons/hi2'

import { formatterPrice } from '../queries'

interface Props {
  product: UbaProduct & { quantity?: number }
  selected?: UbaProduct & { quantity: number }
  handleSelect: (productId: number) => void
  handleChangeQuantity: (productId: number, dir: 'less' | 'more') => void
  handleRemove: (productId: number) => void
}

export function ProductCard ({ product, handleSelect, selected, handleChangeQuantity, handleRemove }: Props): JSX.Element {
  return (
    <div
      key={product.productID}
      className='grid grid-cols-[auto,_160px] justify-between px-4 py-3 bg-zinc-100 w-full box-border rounded-md'
    >
      <div className='flex flex-col gap-2'>
        <h4 className='text-lg p-0 m-0 mb-2'>{product.productName}{' '}
          <span className='px-1 py-0.5 bg-blue-600 text-white rounded-md text-xs w-12 whitespace-pre'>
            {product.stock}
          </span>
        </h4>
        <p className='text-zinc-800'>
          <span title='Origin Country'>{product.countryOrigin}</span>,{' '}
          <span title='Manufacturer'>{product.manufacturer}</span>,{' '}
          <span title='Generic Name'>{product.genericName}</span>
        </p>
        <p className='text-zinc-800'>
          <span title='Strength'>{product.strength}</span>
          <span title='Strength Unit'>{product.strengthUnit}</span>,{' '}
          <span title='Dosage Form'>{product.dosageForm}</span>,{' '}
          <span title='Additional Details'>
            {product.secondaryProductAttributesName}
          </span>
        </p>
        <p className='text-zinc-400 text-sm mt-2'>Product Id: {product.productID} | DIN: {product.dinNumber}</p>
      </div>

      <div className='flex flex-col justify-between items-end'>
        <div className='flex flex-col gap-0.5 items-end'>
          <span
            className='text-lg p-0 m-0'
          >{formatterPrice.format(Number(product.price) * (product.quantity ?? 1))}
          </span>
          {product.quantity && (
            <span
              className='text-xs text-zinc-600 p-0 m-0'
            >{formatterPrice.format(Number(product.price))} x {(product.quantity ?? 1)}
            </span>
          )}
        </div>
        <div className='flex flex-row gap-2 justify-end items-center'>
          {typeof product.quantity === 'number' && product.minimumOrderQty > product.quantity && (
            <span className='text-blue-600 text-xs'>min: {product.minimumOrderQty}</span>
          )}
          {!selected
            ? (
              <button
                className='w-6 h-6 rounded-md bg-zinc-300 flex items-center justify-center font-medium'
                onClick={() => handleSelect(product.productID)}
              >
                <HiPlus />
              </button>
            )
            : (
              <>
                <button
                  className='w-6 h-6 rounded-md bg-zinc-300 flex items-center justify-center font-medium'
                  onClick={() => handleChangeQuantity(product.productID, 'less')}
                >
                  <HiMinus />
                </button>
                <span className='font-medium'>{selected.quantity}</span>
                <button
                  className='w-6 h-6 rounded-md bg-zinc-300 flex items-center justify-center font-medium'
                  onClick={() => handleChangeQuantity(product.productID, 'more')}
                >
                  <HiPlus />
                </button>
                <button
                  className='w-6 h-6 rounded-md bg-red-500 text-white flex items-center justify-center font-medium'
                  onClick={() => handleRemove(product.productID)}
                >
                  <HiXMark />
                </button>
              </>
            )}
        </div>
      </div>
    </div>
  )
}
